import { Component, OnInit, Inject, NgZone } from '@angular/core';
import { Player } from '../../objects/player'
import { LocalStorageService } from '../../services/local-storage.service';
import { PlayerService } from '../../services/player.service';
import { MatDialog } from '@angular/material/dialog';
import { LoginDialogComponent } from '../login-dialog/login-dialog.component';
import { Router } from '@angular/router';
import { CreateAccountComponent } from '../create-account/create-account.component';
import { SocialAuthService } from "@abacritt/angularx-social-login";

@Component({
  selector: 's18-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {
  _player: Player;
  _homeName = "HOME";
  _show: boolean = true;

  logos = [
    { src: './assets/images/logo-12-black-red.png', height: 65 },
    { src: './assets/images/logo-12-black-green.png', height: 65 },
    { src: './assets/images/logo-11.png', height: 65 }
  ];
  imageIndex = 0;
  isFixed: boolean = false;

  constructor(
    private _playerService: PlayerService,
    private authService: SocialAuthService,
    private _localStorageService: LocalStorageService,
    private _router: Router,
    public _loginDialog: MatDialog,
    private zone: NgZone) {
    zone.run(() => {
      window.addEventListener('scroll', this.scroll, true);
    })
  }

  scroll = (): void => {
    if (window.pageYOffset > 0) {
      this.isFixed = true;
    } else {
      this.isFixed = false;
    }
  }

  getHeaderStyle() {
    if (this.isFixed) {
      return "fixed";
    } else {
      return "transparent";
    }

  }

  goTo(url: string) {
    this._router.navigateByUrl(url);
  }

  ngOnInit() {
    this._show = !this._localStorageService.get("hideHeader");
    this.getPlayer();
  }

  getHomeName() {
    if (this._player) {
      this._homeName = 'DASHBOARD';
      return;
    }
    this._homeName = 'HOME';
    return this._homeName;
  }

  isLoggedIn() {
    this._player = this._playerService.getLoggedInPlayerInfo();
    if (this._player) {
      this.getHomeName();
      return true;
    }
    return false;
  }

  openDialog(): void {
    let dialogRef = this._loginDialog.open(LoginDialogComponent, {
      width: '500px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getPlayer();
        this._router.navigateByUrl("/dashboard");
      }
    });
  }

  showRegisterDialog() {
    let dialogRef = this._loginDialog.open(CreateAccountComponent, {
      width: '500px'
    });

    dialogRef.afterClosed().subscribe(resp => {
      if (resp) {
        this.getPlayer();
        this._router.navigateByUrl("/dashboard");;
      }
    });
  }

  getPlayer(): Player {
    this._player = this._playerService.getLoggedInPlayerInfo();
    return this._player;
  }

  switchLogo(image: any) {
    this.imageIndex = this.imageIndex + 1;
    if (this.imageIndex === this.logos.length) {
      this.imageIndex = 0;
    }
    image.srcElement.src = this.logos[this.imageIndex].src;
    image.srcElement.height = this.logos[this.imageIndex].height;
  }

  logout(): void {
    this.authService.signOut();
    this._localStorageService.clearAll();
    this.getPlayer();
    this._router.navigateByUrl("");
  }
}
